import sileo from 'sileo';

const Allowances = new sileo.Model('hqzen', 'allowances');
const EmploymentAllowances = new sileo.Model('bposeats', 'job-offer-request-allowances');

const actions = {
    fetchAllowances(context, data) {
      return Allowances.objects.filter(data);
    },

    fetchEmploymentAllowances(context, data) {
      return EmploymentAllowances.objects.filter();
    },
};

export default {
    namespaced: true,
    actions,
};
